import IncidenciaTipoForm from "./IncidenciaTipoForm";
export default IncidenciaTipoForm;